import { ProductionStationTypes } from '@/store/types'

export default {
  methods: {
    isProductionStationPrimaryType(type) {
      if(type == ProductionStationTypes.cuttingBreakout || type == ProductionStationTypes.furnaceUnload)
        return false
      return true
    }
  }
}